import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Table } from './table';
import {Ng2SmartTableModule} from "ng2-smart-table";
import {BooleanComponent} from "./booleanComponent/booleanComponent";
import {CalendarComponent} from "./calendarComponent/calendarComponent";
import {DlDateTimeDateModule, DlDateTimePickerModule} from "angular-bootstrap-datetimepicker";
import {TextComponent} from "./textComponent/textComponent";
import {DropdownComponent} from "./dropdownComponent/dropdownComponent";
import {DropdownMComponent} from "./dropdownMComponent/dropdownMComponent";
import {NgSelectModule} from "@ng-select/ng-select";

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    Ng2SmartTableModule,
    DlDateTimeDateModule,
    DlDateTimePickerModule,
    NgSelectModule,
  ],
  providers: [],
  exports: [
    Table,
    TextComponent,
    DropdownComponent,
    DropdownMComponent,
    CalendarComponent,
    BooleanComponent
  ],
    declarations: [Table, BooleanComponent, CalendarComponent, TextComponent, DropdownComponent, DropdownMComponent]
})
export class TableModule {}
